import React, { useContext } from 'react';
import { AgentContext } from '../../context/AgentContext';

function CardBlock({card, handleSelectCard}) {
    const {isB2B} = useContext(AgentContext)
    return (
        <div className="subscriptionOptionWrapper">
            <div class="quilityNestedBlockHeader subscriptionOptionHeader">
                <div class="subscriptionTitle">{card.card.brand} Ending in {card.card.last4}</div>
            </div>
            <div className="subcriptionOptionContent">
                <div className="quilityDataLine">
                    <div className="quilityDataLineTitle">Expires</div>
                    <span className="quilityDataLineValue">{card.card.exp_month}/{card.card.exp_year}</span>
                </div>
                <div className="quilityDataLine">
                    <div className={`statusItem ${isB2B ? 'b2b ' : ''}solidQuilityActiveButton`} onClick={()=>handleSelectCard(card.id)}>Use This Card</div>
                </div>
            </div>
        </div>
    );
}

export default CardBlock;
